export default __webpack_public_path__ + "static/solid-catalogue-20318a04bfe2f11e4b8e02ab07375869.pdf";